export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-connected.3e90c3ad274bd7063b7c315b02f186fa.png";